import { Grid, TextField, Typography } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { useState } from "react";
import { LocalizeContextProps, Translate, withLocalize } from 'react-localize-redux';

import { ButtonAccept, ButtonEdit } from '../mini_components';

import { BMIType } from '.';
import { buildBmiEntry, isInvalidMeasurement } from './bmiEntry';

interface Props extends LocalizeContextProps {
    elementSelected:(bmi:BMIType) => void
}

const RedTypography = withStyles({
    root: {
      color: "red"
    }
  })(Typography);

function BMIField(props: Props) {
    
    const [submitted, setSubmitted] = useState(false);
    const [saved, setSaved] = useState(false);
    const [weight, setWeight] = useState<string|boolean>(false);
    const [height, setHeight] = useState<string|boolean>(false);

    // SHER-1045: everything below is derived from the two inputs on each render, so the
    // errors and the IMC preview cannot drift out of sync with what is typed (the old
    // effect-synced copies let the height effect clear the weight error).
    const errorWeight = isInvalidMeasurement(weight);
    const errorHeight = isInvalidMeasurement(height);
    const entry = buildBmiEntry(weight, height);
    const bmi = entry.ok ? entry.entry.bmi : null;
    const showError = submitted && !entry.ok;

    function updateWeight(value:string){
        console.log(value);
        setWeight(value);
    }

    function saveBMI(){
        // SHER-1045: weight and height are each optional; the IMC only exists when both are.
        setSubmitted(true);
        if(entry.ok){
            setSaved(true);
            const bmiElement:BMIType = entry.entry;
            props.elementSelected(bmiElement);
        }
    }
    function editBMI(){
        setSaved(false);
    }

    return(
        <Grid container spacing={3}>
            {/* <Grid item xs={12}>
                <Typography variant="body2" component="span">{props.translate("hospital.bmi")}</Typography>
            </Grid> */}
            {
                !saved &&
                <Grid item xs={12}>
                    <TextField label={props.translate("hospital.bmi-weight")} variant="outlined" error={errorWeight || showError}
                        onChange={(e) => updateWeight(e.target.value)} value={weight === false ? "" : weight}/>
                    <TextField label={props.translate("hospital.bmi-height")} style={{marginLeft: '20px'}} variant="outlined" error={errorHeight || showError}
                        onChange={(e) => setHeight(e.target.value)} value={height === false ? "" : height} />
                </Grid>
            }
            {
                saved && 
                <Grid item xs={12}>
                    {typeof(bmi) === 'number' && <Typography variant="h3" component="span">Result : {bmi.toFixed(2)}</Typography>}
                    <ButtonEdit onClick={editBMI} ><Translate id="general.edit" /></ButtonEdit>
                </Grid>
            }
            
            {
                (bmi && !saved) &&
                <Grid item xs={12}>
                    <Typography variant="body2" component="span">Result : {typeof(bmi) === 'number' ? bmi.toFixed(2) : "undefined"}</Typography>
                </Grid>
            }
            {
                showError &&
                <Grid item xs={12}>
                    <RedTypography variant="body2" data-testid="bmi-error-message"><Translate id="hospital.bmi-error-message" /></RedTypography>
                </Grid>
            }
            {
                !saved &&
                <Grid container item xs={12} spacing={1}>
                    <Grid item>
                        <ButtonAccept onClick={saveBMI}><Translate id="general.add" /></ButtonAccept> 
                    </Grid>
                </Grid>
            }
        </Grid>
    )
}

export default withLocalize(BMIField);